<template>
  <div class="wla">
    <div class="wla-head">
      <div>
        <h5 class="wla-title">Auditoria de Vagas</h5>
        <p class="wla-desc">Registro de realocações: quem declinou e quem assumiu a vaga (lista de espera → confirmado).</p>
      </div>
      <div class="wla-filter">
        <select class="form-control form-control-sm" v-model="groupId" @change="reload">
          <option :value="null">Todos os grupos</option>
          <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.name }}</option>
        </select>
      </div>
    </div>

    <div v-if="loading" class="wla-loading">
      <b-spinner small variant="primary"></b-spinner> Carregando…
    </div>

    <div v-else-if="!items.length" class="wla-empty">
      <i class="bx bx-list-check"></i>
      <div>Nenhuma realocação registrada ainda.</div>
      <small>Quando alguém declinar e uma pessoa da lista de espera for promovida, o registro aparece aqui.</small>
    </div>

    <div v-else class="table-responsive">
      <table class="table table-centered table-nowrap table-hover">
        <thead>
          <tr>
            <th>Data/Hora</th>
            <th>Grupo</th>
            <th>Liberou a vaga</th>
            <th></th>
            <th>Assumiu</th>
            <th class="text-center">Vagas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in items" :key="row.id">
            <td style="font-size:12px">{{ formatDate(row.created_at) }}</td>
            <td><span class="badge badge-soft-secondary font-size-12">{{ row.group || '—' }}</span></td>
            <td>
              <template v-if="row.declined">
                <div class="font-size-13 font-weight-medium">{{ row.declined.name }}</div>
                <div class="text-muted font-size-11">{{ row.declined.email }}</div>
                <span class="badge font-size-11" :class="row.freed_by_status === 5 ? 'badge-soft-secondary' : 'badge-soft-danger'">
                  {{ row.freed_by_status === 5 ? 'Inativado' : 'Declinou' }}
                </span>
              </template>
              <span v-else class="text-muted">—</span>
            </td>
            <td class="text-center"><i class="bx bx-right-arrow-alt" style="font-size:18px;color:#34c38f"></i></td>
            <td>
              <template v-if="row.promoted">
                <div class="font-size-13 font-weight-medium">{{ row.promoted.name }}</div>
                <div class="text-muted font-size-11">{{ row.promoted.email }}</div>
                <span class="badge badge-soft-success font-size-11">Confirmado</span>
              </template>
              <span v-else class="text-muted">—</span>
            </td>
            <td class="text-center font-weight-bold">{{ row.seats }}</td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-end">
        <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" @input="fetch" class="mb-0"></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'

export default {
  name: 'WaitlistAudit',
  data () {
    return {
      items: [],
      groups: [],
      groupId: null,
      currentPage: 1,
      perPage: 20,
      total: 0,
      loading: false
    }
  },
  mounted () {
    this.loadGroups()
    this.fetch()
  },
  methods: {
    async loadGroups () {
      try {
        const res = await http.get('/admin/groups', { params: { limit: 200 } })
        const data = res.data && res.data.data ? res.data.data : (res.data || [])
        this.groups = Array.isArray(data) ? data : []
      } catch (e) {
        this.groups = []
      }
    },
    reload () {
      this.currentPage = 1
      this.fetch()
    },
    async fetch () {
      this.loading = true
      try {
        const params = { page: this.currentPage, limit: this.perPage }
        if (this.groupId) params.group_id = this.groupId
        const res = await http.get('/admin/waitlist-audit', { params })
        this.items = res.data.data || []
        this.total = res.data.total || 0
        this.perPage = res.data.per_page || this.perPage
      } catch (e) {
        this.items = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    formatDate (v) {
      if (!v) return '—'
      try {
        return new Date(v).toLocaleString('pt-BR')
      } catch (e) {
        return v
      }
    }
  }
}
</script>

<style scoped>
.wla-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap; margin-bottom: 12px; }
.wla-title { font-size: 15px; font-weight: 700; color: #1a1d26; margin: 0; }
.wla-desc { font-size: 12.5px; color: #8b90a5; margin: 4px 0 0; max-width: 560px; }
.wla-filter select { min-width: 200px; }
.wla-loading { padding: 28px; text-align: center; color: #8b90a5; font-size: 13px; }
.wla-empty { padding: 40px 20px; text-align: center; color: #8b90a5; }
.wla-empty i { font-size: 34px; display: block; margin-bottom: 8px; color: #c5cad6; }
.wla-empty small { display: block; margin-top: 4px; font-size: 11.5px; }
.font-weight-medium { font-weight: 500; }
</style>
